import React from 'react';
import { Link } from 'react-router-dom';
// ANTD
import Modal from 'antd/lib/modal';
import Select from 'antd/lib/select';
import Input from 'antd/lib/input';
import Form from 'antd/lib/form';
import Card from 'antd/lib/card';
import Tooltip from 'antd/lib/tooltip';
import notification from 'antd/lib/notification';
// APOLLO
import Button from 'components/common/Button';
import createQuestionnaire from 'ApolloClient/Mutations/createQuestionnaire';
import questionTemplatesQuery from 'ApolloClient/Queries/questionTemplates';
import questionnairesByClientIdQuery from 'ApolloClient/Queries/questionnairesByClientId';
import { graphql, compose } from 'react-apollo';
import questionnairesByClientId from 'ApolloClient/Queries/questionnairesByClientId';
//
import ChooseEmailTemplateButton from './ChooseEmailTemplateButton';

// CONSTANTS
// =============================================
const { TextArea } = Input;
const Option = Select.Option;
const FormItem = Form.Item;

export class SendQuestionnaireModal extends React.Component {
  constructor(props) {
    super(props);
    let email = (this.props && this.props.email) || '';
    this.state = {
      visible: false,
      loading: false,
      emailMessage: '',
      emailSubject: '',
      email,
      questionTemplateId: null,
    };
  }
  
  getParams = () => {
    const { email, emailMessage, questionTemplateId, emailSubject } = this.state;
    if (!email || !emailMessage || !questionTemplateId) {
      this.setState({ loading: false });
      return notification.error({ message: 'please fill out all the fields!' });
    }
    let params = {
      email,
      emailMessage,
      emailSubject,
      questionTemplateId,
      clientId: this.props.clientId,
    };
    return params;
  };

  getRefetchQueries = () => {
    return [{ query: questionnairesByClientIdQuery, variables: { _id: this.props.clientId } }];
  };

  onSuccessfullyValidated = variables => {
    let refetchQueries = this.getRefetchQueries();
    this.props
      .createQuestionnaire({ variables, refetchQueries })
      .then(() => {
        this.setState({ loading: false, visible: false });
        notification.success({ message: 'Questionnaire sent!' });
      })
      .catch(err => {
        this.setState({ loading: false });
        console.log(err);
      });
  };

  onSubmit = () => {
    if (this.state.loading) {
      return null;
    }
    this.setState({ loading: true });

    let params = this.getParams();

    if (params) {
      let variables = { params };
      this.onSuccessfullyValidated(variables);
    }
  };

  onTemplateSelected = template => {
    return this.setState({
      emailMessage: template.body,
      emailSubject: template.subject,
    });
  };
  renderContent = () => {
    return (
      <div>
        <div style={{ paddingBottom: 12 }}>
          <FormItem label="Which Template Should We Use?">
            <Select
              style={{ width: '100%' }}
              size="large"
              placeholder="Choose a questionnaire template..."
              onChange={questionTemplateId => this.setState({ questionTemplateId })}
            >
              {this.props.questionTemplatesQuery.questionTemplates.map(item => {
                return <Option key={item._id}>{item.title}</Option>;
              })}
            </Select>
          </FormItem>
        </div>

        <FormItem label="Setup Your Questionnaire Email:">
          <FormItem style={{ marginBottom: 10 }}>
            <Input
              onChange={e => this.setState({ email: e.target.value })}
              value={this.state.email}
              placeholder="Email..."
              size="large"
            />
          </FormItem>
          <ChooseEmailTemplateButton onTemplateSelected={this.onTemplateSelected} />
          <FormItem>
            <Input
              onChange={e => this.setState({ emailSubject: e.target.value })}
              placeholder="Email subject line..."
              value={this.state.emailSubject}
              size="large"
            />
          </FormItem>
          <FormItem>
            <TextArea
              placeholder={`Thank you for yor business. Please review the attached invoice.`}
              size="large"
              onChange={e => this.setState({ emailMessage: e.target.value })}
              value={this.state.emailMessage}
              rows={6}
              style={{ maxWidth: '100%' }}
            />
          </FormItem>
        </FormItem>
        {this.state.questionTemplateId && (
          <div style={{ textAlign: 'right' }}>
            <Tooltip title="Click here for a preivew of what your client will see...">
              <Link target="_blank" to={`/questionnaire-preview/${this.state.questionTemplateId}`}>
                SEE PREVIEW BEFORE SENDING
              </Link>
            </Tooltip>
          </div>
        )}
        <Button style={{ marginTop: 15 }} type="primary" size="large" onClick={this.onSubmit}>
          {this.state.loading ? 'Sending...' : 'Send to Client'}
        </Button>
      </div>
    );
  };
  render() {
    return (
      <div>
        <Button
          {...this.props.buttonProps}
          type="primary"
          onClick={() => this.setState({ visible: !this.state.visible })}
        >
          Send Questionnaire
        </Button>
        <Modal
          title="Send Questionnaire"
          visible={this.state.visible}
          footer={null}
          onCancel={() => this.setState({ visible: false })}
        >
          <Card
            style={{ minHeight: 300 }}
            bordered={false}
            loading={this.state.loading || this.props.questionTemplatesQuery.loading}
          >
            {!this.props.questionTemplatesQuery.loading && this.renderContent()}
          </Card>
        </Modal>
      </div>
    );
  }
}

export default compose(
  graphql(createQuestionnaire, { name: 'createQuestionnaire' }),
  graphql(questionTemplatesQuery, { name: 'questionTemplatesQuery' }),
)(SendQuestionnaireModal);



// WEBPACK FOOTER //
// ./src/components/common/SendQuestionnaireModal/index.js